import { action, Action, persist } from 'easy-peasy';

export interface UserFeedbackDialogModel {
  feedbackDialogOpen: boolean;
  setFeedbackDialogOpen: Action<UserFeedbackDialogModel, boolean>;
  feedbackDialogShouldOpenAgainAt: string;
  setFeedbackDialogShouldOpenAgainAt: Action<UserFeedbackDialogModel, string>;
}

const userFeedbackDialogModel: UserFeedbackDialogModel = {
  feedbackDialogOpen: true,
  setFeedbackDialogOpen: action((state, payload) => {
    state.feedbackDialogOpen = payload;
  }),
  feedbackDialogShouldOpenAgainAt: '',
  setFeedbackDialogShouldOpenAgainAt: action((state, payload) => {
    state.feedbackDialogShouldOpenAgainAt = payload;
  }),
};

export default persist(userFeedbackDialogModel, {
  allow: ['feedbackDialogOpen', 'feedbackDialogShouldOpenAgainAt'],
  storage: 'localStorage',
});
